import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IApiresponse } from "src/app/_models";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";

/**
 * All purchase-order related API calls (BillingService).
 */
@Injectable({
  providedIn: "root",
})
export class PurchaseOrderService {

  constructor(
    private http: HttpClient,
    private claimsHeaderService: ClaimsHeaderService
  ) { }

  /** Purchase order raised for the logged-in organisation. */
  GetOrgPurchaseOrderDetails(organisationId: number): Observable<IApiresponse<any>> {
    let params = new HttpParams();
    params = params.append("organisationId", organisationId.toString());
    return this.http.get<IApiresponse<any>>(`${environment.billingApiUrl}GetOrgPurchaseOrderDetails`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  /** PO / implementation-charge receipt documents for the logged-in organisation. */
  GetOrgPurchaseOrderDocuments(organisationId: number): Observable<IApiresponse<any[]>> {
    let params = new HttpParams();
    params = params.append("organisationId", organisationId.toString());
    return this.http.get<IApiresponse<any[]>>(`${environment.billingApiUrl}GetOrgPurchaseOrderDocuments`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  /** Upload the accepted Purchase Order PDF to OrgPurchaseOrderReceipt (multipart). */
  SaveOrgPurchaseOrderReceipt(organisationId: number, file: File): Observable<IApiresponse<number>> {
    const formData = new FormData();
    formData.append('RequestData', organisationId.toString());
    formData.append('ReceiptFiles', file, file.name);
    return this.http.post<IApiresponse<number>>(
      `${environment.billingApiUrl}SavePOReceipt`,
      formData,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
    );
  }

  /** Upload the Implementation Agreement PDF to OrgImplementationAgreementReceipt (multipart). */
  SaveImplementationAgreementReceipt(organisationId: number, file: File): Observable<IApiresponse<number>> {
    const formData = new FormData();
    formData.append('RequestData', organisationId.toString());
    formData.append('ReceiptFiles', file, file.name);
    return this.http.post<IApiresponse<number>>(
      `${environment.billingApiUrl}SaveImplementationAgreementReceipt`,
      formData,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
    );
  }

  /**
   * Upload both purchase-order receipts (accepted PO PDF + signed Implementation Agreement PDF)
   * in a single multipart call. Either file may be null.
   */
  SavePOAndImplementationReceipts(organisationId: number, purchaseOrderFile: File | null, implementationAgreementFile: File | null): Observable<IApiresponse<number>> {
    const formData = new FormData();
    formData.append('RequestData', organisationId.toString());
    if (purchaseOrderFile) {
      formData.append('PurchaseOrderFile', purchaseOrderFile, purchaseOrderFile.name);
    }
    if (implementationAgreementFile) {
      formData.append('ImplementationAgreementFile', implementationAgreementFile, implementationAgreementFile.name);
    }
    return this.http.post<IApiresponse<number>>(
      `${environment.billingApiUrl}SavePOAndImplementationReceipts`,
      formData,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
    );
  }
}
